// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3e75f51","453":"12f5a19b","455":"a4eca2f9","977":"522d8899"}[chunkId] + ".chunk.js";
};